import Swiper, { Navigation, Pagination, Lazy } from 'swiper/bundle';

Swiper.use([Navigation, Pagination, Lazy]);

let swipers = document.querySelectorAll(".slider"); //Находим все слайдеры в tab'ах

swipers.forEach(value => {
  let swiper = new Swiper(value, {
    slidesPerView: 3,
    spaceBetween: 30,
    lazy: true,
    init: false,
    navigation: {
      nextEl: value.closest('.slider__wrapper').querySelector('.swiper-button-next'), //инициализируем кнопки управления у ДАННОГО слайдера через поиск querySelector()
      prevEl: value.closest('.slider__wrapper').querySelector('.swiper-button-prev'), //инициализируем кнопки управления у ДАННОГО слайдера через поиск querySelector()
    },

    pagination: {
      el: value.closest('.slider__wrapper').querySelector(".swiper-pagination"), //инициализируем пагиницию у ДАННОГО слайдера через поиск querySelector()
      clickable: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
        /* allowTouchMove: false, */
      },
      990: {
        slidesPerView: 1,
        /* allowTouchMove: false, */
      },
      991: {
        slidesPerView: 3,
        /* allowTouchMove: true, */

      },
    },
    observer: true,
    observerParents: true
  });

  swiper.on("slideChange afterInit init", function() {
    let currentSlide = this.activeIndex + 1;
    value.closest('.slider__wrapper').querySelector('.counter').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>`});

  swiper.init();
});

var totalSiteMainSlide = $('.SiteMain .swiper-wrapper .swiper-slide').length;
$('.tab_content:nth-child(1) .swiper__mobile .counter').append(`<span class="counter__total">
/${totalSiteMainSlide}
</span>`);
var totalSmmMainSlide = $('.SmmMain .swiper-wrapper .swiper-slide').length;
$('.tab_content:nth-child(2) .swiper__mobile .counter').append(`<span class="counter__total">
/${totalSmmMainSlide}
</span>`);

var totalContextMainSlide = $('.ContextMain .swiper-wrapper .swiper-slide').length;
$('.tab_content:nth-child(3) .swiper__mobile .counter').append(`<span class="counter__total">
/${totalContextMainSlide}
</span>`);
var totalBrandMainSlide = $('.BrandMain .swiper-wrapper .swiper-slide').length;
$('.tab_content:nth-child(4) .swiper__mobile .counter').append(`<span class="counter__total">
/${totalBrandMainSlide}
</span>`);

var totalPresentMainSlide = $('.PresentMain .swiper-wrapper .swiper-slide').length;
$('.tab_content:nth-child(5) .swiper__mobile .counter').append(`<span class="counter__total">
/${totalPresentMainSlide}
</span>`);
var totalPolyMainSlide = $('.PolyMain .swiper-wrapper .swiper-slide').length;
$('.tab_content:nth-child(6) .swiper__mobile .counter').append(`<span class="counter__total">
/${totalPolyMainSlide}
</span>`);

let brands = new Swiper('.mySwiper', {
  slidesPerView: 4,
  spaceBetween: 30,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },

  breakpoints: {
    320: {
      slidesPerView: 3,
    },
    990: {
      slidesPerView: 3,
    },
    991: {
      slidesPerView: 4,
    },
  },

});


const caseBtn = document.querySelectorAll('.btn-more');
const caseContent = document.querySelector('.portfolio__content__wrapper');

//==========
let totalSITESlide = $('.site .swiper-wrapper .swiper-slide').length;
let totalSMMSlide = $('.smms .swiper-wrapper .swiper-slide').length;
let totalCONTEXTSlide = $('.context__content .swiper-wrapper .swiper-slide').length;
let totalBRANDINGSlide = $('.branding .swiper-wrapper .swiper-slide').length;
let totalPRESENTATIONSlide = $('.presentation .swiper-wrapper .swiper-slide').length;
let totalPOLYGRAPHYSlide = $('.polygraphy .swiper-wrapper .swiper-slide').length;
//==========

var site = new Swiper(".site", {
  simulateTouch: false,
  init: false,
  observer: true,
  observeParents: true,
  autoHeight: true,
  lazy: true,
  spaceBetween: 30,
  calculateHeight:true,
  navigation: {
    nextEl: ".swiper-button-content-next-site",
    prevEl: ".swiper-button-content-prev-site",
  },
  pagination: {
    el: ".swiper-pagination-site",
    clickable: true,
  },  
});


site.on("slideChange afterInit init", function () {
  let currentSlide = this.activeIndex + 1;
  let totalSlide = this.slides.length;

  document.querySelector('.counter-site').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>  
  <span class="counter__total">
    <span>/ </span>${totalSITESlide < 10 ? '0' + totalSITESlide : totalSITESlide}
  </span>`;
});


var smm = new Swiper(".smms", {
   simulateTouch: false,
  init: false,
  observer: true,
  observeParents: true,
  autoHeight: true,
  lazy: true,
  spaceBetween: 30,
  calculateHeight:true,
  navigation: {
    nextEl: ".swiper-button-content-next-smm",
    prevEl: ".swiper-button-content-prev-smm",
  },
  pagination: {
    el: ".swiper-pagination-smm",
    clickable: true,
  },
});

smm.on("slideChange afterInit init", function () {
  let currentSlide = this.activeIndex + 1;
  let totalSlide = this.slides.length;
  
  document.querySelector('.counter-smm').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>  
  <span class="counter__total">
    <span>/ </span>${totalSMMSlide < 10 ? '0' + totalSMMSlide : totalSMMSlide}
  </span>`;
});

var context__content = new Swiper(".context__content", {
   simulateTouch: false,
  init: false,
  observer: true,
  observeParents: true,
  autoHeight: true,
  lazy: true,
  spaceBetween: 30,
  calculateHeight:true,
  navigation: {
    nextEl: ".swiper-button-content-next-context",
    prevEl: ".swiper-button-content-prev-context",
  },
  pagination: {
    el: ".swiper-pagination-context",
    clickable: true,
  },
});

context__content.on("slideChange afterInit init", function () {
  let currentSlide = this.activeIndex + 1;
  let totalSlide = this.slides.length;
  document.querySelector('.counter-context').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>  
  <span class="counter__total">
    <span>/ </span>${totalCONTEXTSlide < 10 ? '0' + totalCONTEXTSlide : totalCONTEXTSlide}
  </span>`;
});

var branding = new Swiper(".branding", {
   simulateTouch: false,
  init: false,
  observer: true,
  observeParents: true,
  autoHeight: true,
  lazy: true,
  spaceBetween: 30,
  calculateHeight:true,
  navigation: {
    nextEl: ".swiper-button-content-next-branding",
    prevEl: ".swiper-button-content-prev-branding",
  },
  pagination: {
    el: ".swiper-pagination-branding",
    clickable: true,
  },
});

branding.on("slideChange afterInit init", function () {
  let currentSlide = this.activeIndex + 1;
  let totalSlide = this.slides.length;
  document.querySelector('.counter-branding').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>  
  <span class="counter__total">
    <span>/ </span>${totalBRANDINGSlide < 10 ? '0' + totalBRANDINGSlide : totalBRANDINGSlide}
  </span>`;
});

var presentation = new Swiper(".presentation", {
   simulateTouch: false,
  init: false,
  autoHeight: true,
  observer: true,
  observeParents: true,
  lazy: true,
  spaceBetween: 30,
  calculateHeight:true,
  navigation: {
    nextEl: ".swiper-button-content-next-presentation",
    prevEl: ".swiper-button-content-prev-presentation",
  },
  pagination: {
    el: ".swiper-pagination-presentation",
    clickable: true,
  },
});

presentation.on("slideChange afterInit init", function () {
  let currentSlide = this.activeIndex + 1;
  let totalSlide = this.slides.length;
  document.querySelector('.counter-presentation').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>  
  <span class="counter__total">
    <span>/ </span>${totalPRESENTATIONSlide < 10 ? '0' + totalPRESENTATIONSlide : totalPRESENTATIONSlide}
  </span>`;
});

var polygraphy = new Swiper(".polygraphy", {
   simulateTouch: false,
  init: false,
  autoHeight: true,
  observer: true,
  observeParents: true,
  lazy: true,
  spaceBetween: 30,
  calculateHeight:true,
  navigation: {
    nextEl: ".swiper-button-content-next-polygraphy",
    prevEl: ".swiper-button-content-prev-polygraphy",
  },
  pagination: {
    el: ".swiper-pagination-polygraphy",
    clickable: true,
  },
});

polygraphy.on("slideChange afterInit init", function () {
  let currentSlide = this.activeIndex + 1;
  let totalSlide = this.slides.length;
  document.querySelector('.counter-polygraphy').innerHTML = `
  <span class="counter__current">
  ${currentSlide < 10 ? '0' + currentSlide : currentSlide}
  </span>  
  <span class="counter__total">
    <span>/ </span>${totalPOLYGRAPHYSlide < 10 ? '0' + totalPOLYGRAPHYSlide : totalPOLYGRAPHYSlide}
  </span>`;
});

caseBtn.forEach(emploee => emploee.addEventListener('click', function() {
  document.body.style.overflow = 'hidden';
  caseContent.classList.add('case__active');
  $('#chaty-widget-0 .chaty-widget').addClass('bottomWidget');
  $('ul.tabs#portfolio').appendTo('.portfolio__content__wrapper .services__content .portfolio__content .portfolio__content__container');
  $('.portfolio .portfolio__container .services__content .tab_container').appendTo('.portfolio__content__wrapper .services__content .portfolio__content');
  if(emploee.getAttribute('data-site')){
    var siteA = emploee.getAttribute('data-site');
    site.slideTo(siteA);
  }

  if(emploee.getAttribute('data-smm')){
    var smmA = emploee.getAttribute('data-smm');
    smm.slideTo(smmA);
  }

  if(emploee.getAttribute('data-context')){
    var contextA = emploee.getAttribute('data-context');
    context__content.slideTo(contextA);
  }

  if(emploee.getAttribute('data-branding')){
    var brandingA = emploee.getAttribute('data-branding');
    branding.slideTo(brandingA);
  }

  if(emploee.getAttribute('data-presentation')){
    var presentationA = emploee.getAttribute('data-presentation');
    presentation.slideTo(presentationA);
  }

  if(emploee.getAttribute('data-polygraphy')){
    var polygraphyA = emploee.getAttribute('data-polygraphy');
    polygraphy.slideTo(polygraphyA);
  }
  
}));

site.init();
smm.init();
context__content.init();
branding.init();
presentation.init();
polygraphy.init();
